export default __webpack_public_path__ + "static/media/msn.feab1bb2.svg";